// removed by extract-text-webpack-plugin
module.exports = {"spread":"spread_3T-Pi","seen":"seen_25L11","partial":"partial_1c0mC","done":"done_2DDPe","active":"active_aQk0E","label":"label_OTIBO"};


//////////////////
// WEBPACK FOOTER
// ./app/components/pagination-page/styles.scss
// module id = 488
// module chunks = 1